import ymaps from '../../../../node_modules/ymaps/dist/ymaps.esm';

export default new class footerMap {
  constructor() {
    this.mapWrapperSelector = 'footer__map-wrap';
    this.mapWrapperPreloaderSelector = 'footer__map__preloader';
    this.mapWrapperVisibleSelector = 'footer__map-wrap_visible';
    this.idSelector = 'data-api-key';
    this.coordinatesSelector = 'data-coordinates';
    this.zoomSelector = 'data-zoom';
    this.markerPath = 'data-marker-path';
    this.titleSelector = 'data-title';
    this.contentSelector = 'data-content';

    this.isContactPage = document.body.getAttribute('data-page-id') === 'service-contact';

    if (!this.isContactPage) {
      const app = document.querySelector(`.${this.mapWrapperSelector}`);
      app.classList.add(this.mapWrapperVisibleSelector);
      this.init();
    }
  }

  init() {
    document.addEventListener('DOMContentLoaded', async () => {
      this.map = await ymaps.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU');
      this.loadMap();
    });
  }

  loadMap() {
    this.map.ready(() => {
      this.initMap();
    });
  }

  initMap() {
    const app = document.querySelector(`.${this.mapWrapperSelector}`);
    try {
      app.classList.add(this.mapWrapperVisibleSelector);
      const coordinates = app.getAttribute(this.coordinatesSelector).split(',');
      const zoomMap = app.getAttribute(this.zoomSelector);
      const markerPath = app.getAttribute(this.markerPath);
      const titleMap = app.getAttribute(this.titleSelector);
      const contentMap = app.getAttribute(this.contentSelector);

      const mapContainer = document.createElement('div');
      mapContainer.classList = 'footer__map';
      app.append(mapContainer);

      const obMap = new this.map.Map(mapContainer, {
        controls: ['zoomControl', 'searchControl'],
        center: [parseFloat(coordinates[0]), parseFloat(coordinates[1])],
        theme: 'islands#dark',
        zoom: zoomMap,
      });

      const placemark = new this.map.Placemark(
        [parseFloat(coordinates[0]), parseFloat(coordinates[1])],
        {
          balloonContentHeader: titleMap,
          balloonContent: contentMap,
        }, {
          preset: 'islands#greenDotIconWithCaption',
          iconLayout: 'default#image',
          iconImageSize: [33, 55],
          iconImageHref: markerPath,
          openTimeout: 500,
        },
      );

      obMap.behaviors.disable('scrollZoom');
      obMap.geoObjects.add(placemark);
      placemark.balloon.open();
      const mapPreloader = document.querySelector(`.${this.mapWrapperPreloaderSelector}`);
      mapPreloader.style.display = 'none';
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Ошибка', error);
    }
  }
}();
